import script from "./Results.vue?vue&type=script&setup=true&lang=js"
export * from "./Results.vue?vue&type=script&setup=true&lang=js"

import "./Results.vue?vue&type=style&index=0&id=41d65d86&lang=scss"

const __exports__ = script;

export default __exports__